import React, { useContext, useEffect, useState } from 'react';
import { Course, UserRole } from '../../types/lms.types';
import { getAxiosTokenInstance } from '../../../utils/axiosInstance';
import { NecttosContext } from '../../../context/NecttosContext';

interface OutcomesViewProps {
  type: 'course' | 'program';
  course: Course;
  userRole: UserRole;
  selectedModule: string;

}

const OutcomesView: React.FC<OutcomesViewProps> = ({ 
  type, 
  course, 
  userRole, 
  selectedModule
}) => {

 const {collegeId} = useContext(NecttosContext); 
  // Mock course outcomes data
const [outcome, setOutcome] = useState<{_id: string, type:string, code: string, title: string, description: string, achievement: string, relatedCourses: string[], collegeId: string, subjectId: string}[]>([])
  useEffect(() => {
    const loadData = async() => {
      const instance = await getAxiosTokenInstance()
      try{
        if(type == 'course'){
          const resp = await instance.get('/college/lms/poco/allCo', {
            params: {
              collegeId,
              subjectId:course.subjectId
            }
          })
          if( resp.data) {
            setOutcome(resp.data.data)
          }
        }else if (type == 'program'){
          const resp = await instance.get('/college/lms/poco/allPo', {
            params: {
              collegeId,
              subjectId:course.subjectId
            }
          })
          if( resp.data) {
            setOutcome(resp.data.data);
          }
        }

      }catch(err){

      }
    }
    loadData();
  },[course, collegeId, type, userRole])

  



  const getAchievementBadge = (level: string) => {
    const baseClasses = "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium";
    
    switch (level) {
      case 'High':
        return `${baseClasses} bg-green-100 text-green-800`;
      case 'Medium':
        return `${baseClasses} bg-yellow-100 text-yellow-800`;
      case 'Low':
        return `${baseClasses} bg-red-100 text-red-800`;
      default:
        return `${baseClasses} bg-gray-100 text-gray-800`;
    }
  };

  const title = type === 'course' ? 'Course Outcomes (CO)' : 'Program Outcomes (PO)';
  const icon = type === 'course' ? '🎯' : '🏆';

  return (
    <div className="p-6 space-y-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div className="flex items-center gap-3">
          <span className="text-2xl">{icon}</span>
          <h2 className="text-xl font-semibold">{title}</h2>
        </div>
        <div className="text-sm text-gray-500">
          {outcome.length} outcomes
        </div>
      </div>

      <div className="grid grid-cols-1 gap-6">
        {outcome?.map((out) => (
          <div
            key={out._id}
            className="bg-white dark:bg-gray-800 rounded-lg shadow border border-gray-200 dark:border-gray-700 overflow-hidden"
          >
            <div className="p-6">
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-blue-100 dark:bg-blue-900 rounded-lg flex items-center justify-center">
                   <span className="text-blue-600 dark:text-blue-400 font-bold text-sm">
  {out.type === 'CO' ? '🎯': '🏆'}
</span>

                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                      {out.title}
                    </h3>
                    <span className={getAchievementBadge(out.achievement)}>
                      {out.achievement} Achievement
                    </span>
                  </div>
                </div>
              </div>

              <p className="text-gray-700 dark:text-gray-300 mb-4 leading-relaxed">
                {out.description}
              </p>
{/* 
              {type === 'course' && 'assessmentMethods' in out && (
                <div className="mb-4">
                  <h4 className="text-sm font-semibold text-gray-900 dark:text-white mb-2">
                    Assessment Methods:
                  </h4>
                  <div className="flex flex-wrap gap-2">
                    {out.assessmentMethods.map((method, index) => (
                      <span
                        key={index}
                        className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300"
                      >
                        {method}
                      </span>
                    ))}
                  </div>
                </div>
              )} */}

              {'relatedCourses' in out && (
                <div>
                  <h4 className="text-sm font-semibold text-gray-900 dark:text-white mb-2">
                    Related Topics:
                  </h4>
                  <div className="flex flex-wrap gap-2">
                    {out.relatedCourses.map((course, index) => (
                      <span
                        key={index}
                        className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300"
                      >
                        
                        {course}
                      </span>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}

        {outcome.length === 0 && (
          <div className="text-center py-12">
            <span className="text-6xl mb-4 block">{icon}</span>
            <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
              No outcomes found
            </h3>
            <p className="text-gray-500">
              No {type} outcomes available for the selected module.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default OutcomesView;
